module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.data.title) ? _c('h4', [_vm._v(_vm._s(this.data.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": this.data.metadata
    }
  }), _vm._v(" "), _c('ul', _vm._l((this.data.report), function(item) {
    return _c('li', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    }), _vm._v(" "), (item.children) ? _c('ListReport', {
      attrs: {
        "data": _vm.formatDataForRecursiveChildComponent(item.children)
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce3515d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ListReport.vue
// module id = 771
// module chunks = 1